import React from 'react';
import { MarkerVisualState } from '../../resolveMarkerVisualState';

const MESSAGE_SQUARE_PATH =
  'M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z';

type CssVars = React.CSSProperties & {
  '--anomaly-accent'?: string;
};

const MarkerIconSvg: React.FC = () => (
  <svg
    className="anomaly-axis-marker__svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      className="anomaly-axis-marker__path"
      d={MESSAGE_SQUARE_PATH}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const MarkerIconLayers: React.FC<{ accent: string }> = ({ accent }) => (
  <span className="anomaly-axis-marker__icon" style={{ '--anomaly-accent': accent } as CssVars}>
    <MarkerIconSvg />
  </span>
);

const AnomalyAxisMarkerIcon: React.FC<{ visualState: MarkerVisualState }> = ({ visualState }) => {
  if (visualState.mode === 'single') {
    return <MarkerIconLayers accent={visualState.accent} />;
  }

  return (
    <span className="anomaly-axis-marker__icon-stack" aria-hidden="true">
      <span
        className="anomaly-axis-marker__half anomaly-axis-marker__half--tl"
        style={{ '--anomaly-accent': visualState.brandScoreAccent } as CssVars}
      >
        <MarkerIconLayers accent={visualState.brandScoreAccent} />
      </span>
      <span
        className="anomaly-axis-marker__half anomaly-axis-marker__half--br"
        style={{ '--anomaly-accent': visualState.averagePositionAccent } as CssVars}
      >
        <MarkerIconLayers accent={visualState.averagePositionAccent} />
      </span>
    </span>
  );
};

export default AnomalyAxisMarkerIcon;
